import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const TrainFilters = ({ onFilterChange, selectedValues }: any) => {
  // Handle filter selection
  const handleSelectChange = (filter: string) => (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value;
    onFilterChange(filter, value);
  };

  // Check if a filter is already selected
  const isFilterSelected = (filter: string, value: string) => {
    return selectedValues[filter] === value;
  };

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2, alignItems: 'center' }}>
      <FormControl variant="outlined" sx={{ minWidth: 120 }}>
        <InputLabel sx={{ fontSize: '0.8rem' }}>Train ID</InputLabel>
        <Select
          value={selectedValues['Train ID']}
          onChange={handleSelectChange('Train ID')}
          sx={{ fontSize: '0.8rem' }}
        >
          {/* <MenuItem value=""><em>None</em></MenuItem> */}
          <MenuItem value={444013}>444013</MenuItem>
          <MenuItem value={450032}>450032</MenuItem>
        </Select>
      </FormControl>
      <FormControl variant="outlined" sx={{ minWidth: 90 }}>
        <InputLabel sx={{ fontSize: '0.8rem' }}>Status</InputLabel>
        <Select
          value={selectedValues['Status']}
          onChange={handleSelectChange('Status')}
          sx={{ fontSize: '0.8rem' }}
        >
          <MenuItem value=""><em>None</em></MenuItem>
          <MenuItem value="ACTION REQUIRED">ACTION REQUIRED</MenuItem>
          <MenuItem value="GOOD">GOOD</MenuItem>
        </Select>
      </FormControl>
      <FormControl variant="outlined" sx={{ minWidth: 90 }}>
        <InputLabel sx={{ fontSize: '0.8rem' }}>Fleet</InputLabel>
        <Select
          value={selectedValues['Fleet']}
          onChange={handleSelectChange('Fleet')}
          sx={{ fontSize: '0.8rem' }}
        >
          <MenuItem value=""><em>None</em></MenuItem>
          <MenuItem value={444}>Fleet 444</MenuItem>
          <MenuItem value={450}>Fleet 450</MenuItem>
        </Select>
      </FormControl>
      <FormControl variant="outlined" sx={{ minWidth: 120 }}>
        <InputLabel sx={{ fontSize: '0.8rem' }}>Start Location</InputLabel>
        <Select
          value={selectedValues['Start Location']}
          onChange={handleSelectChange('Start Location')}
          sx={{ fontSize: '0.8rem' }}
        >
          <MenuItem value=""><em>None</em></MenuItem>
          <MenuItem value="BEDHAMPTON">BEDHAMPTON</MenuItem>
          <MenuItem value="LONDON">LONDON</MenuItem>
        </Select>
      </FormControl>
      <FormControl variant="outlined" sx={{ minWidth: 120 }}>
        <InputLabel sx={{ fontSize: '0.8rem' }}>End Location</InputLabel>
        <Select
          value={selectedValues['End Location']}
          onChange={handleSelectChange('End Location')}
          sx={{ fontSize: '0.8rem' }}
        >
          <MenuItem value=""><em>None</em></MenuItem>
          <MenuItem value="HAVANT">HAVANT</MenuItem>
          <MenuItem value="BRIGHTON">BRIGHTON</MenuItem>
        </Select>
      </FormControl>
      <FormControl variant="outlined" sx={{minWidth: 120}}>
        <InputLabel sx={{ fontSize: '0.8rem' }} >SandBoxes</InputLabel  >
        <Select sx={{ fontSize: '0.8rem' }}>
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          <MenuItem value="Front">Front</MenuItem>
          <MenuItem value="Rear">Rear</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default TrainFilters;
